export default class CLassicQuizzesStats {
  public participationCount: number = null;
  public points: number = null;
}
